import React from "react";

import "./SideNav.scss";
import {
  analysisIcon,
  createIcon,
  helpIcon,
  homeIcon,
  listIcon,
  priceIcon,
} from "assets/icons";
import { NavLink } from "react-router-dom";
import { useTranslation } from "react-i18next";

const SideNav = () => {
  const { t } = useTranslation();

  const menuItems = [
    {
      key: "Home",
      to: "/dashboard/create-survey",
      // src: createIcon,
      src: homeIcon,

      alt: "Create Icon",
      label: t("SIDEMENU.home"),
      enable: true,
    },
    {
      key: "surveys",
      to: "/dashboard/surveys",
      src: listIcon,
      alt: "List Icon",
      label: t("SIDEMENU.surveys"),
      enable: true,
    },
    {
      key: "analysis",
      to: "/dashboard/analysis", // Update path as needed
      src: analysisIcon,
      alt: "Analysis Icon",
      label: t("SIDEMENU.analysis"),
      enable: true,
    },
    {
      key: "support",
      to: "/dashboard/support",
      src: helpIcon,
      alt: "Help Icon",
      label: t("SIDEMENU.support"),
      enable: true,
    },
    {
      key: "pricing",
      to: "/dashboard/pricing", // Update path as needed
      src: priceIcon,
      alt: "Pricing Icon",
      label: t("SIDEMENU.pricing"),
      enable: true,
    },
  ].filter((item) => item.enable);

  return (
    <>
      <nav>
        <ul>
          {menuItems.map((item) => (
            <li key={item?.key || ""}>
              <NavLink to={item?.to || ""}>
                <img src={item?.src || ""} alt={item?.alt || ""} />{" "}
                <span>{item?.label || ""}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>
    </>
  );
};

export default SideNav;
